<if(input)>
    $ {
        const title = input.title || input;
        const subTitle = input.subTitle;
    }
    <h2 class="str-title">
        <str-textual-display ...(title || {}) />
        <if(subTitle)>
            <str-textual-display ...subTitle class="str-title--sub" target="_blank" />
        </if>
    </h2>
</if>
